import { useState, useEffect, useMemo } from 'react';

export const useSearchableModels = (makeId) => {
  const [allModels, setAllModels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const fetchModels = async (brandId) => {
    if (!brandId) {
      setAllModels([]);
      return;
    }

    setLoading(true);
    setError(null);
    
    try {
      console.log('🔄 Fetching vehicle models for brand ID:', brandId);
      
      const response = await fetch(`https://vpic.nhtsa.dot.gov/api/vehicles/GetModelsForMakeId/${brandId}?format=json`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
        },
      });
      
      console.log('📡 Models API Response status:', response.status);
      
      if (!response.ok) {
        throw new Error(`Error fetching models: ${response.status} ${response.statusText}`);
      }
      
      const data = await response.json();
      console.log('📊 Models API Response received, processing data...');
      
      if (data.Results && Array.isArray(data.Results)) {
        console.log('✅ Found', data.Results.length, 'models for brand ID:', brandId);
        
        // Ordenar modelos alfabéticamente
        const sortedModels = data.Results.sort((a, b) => 
          a.Model_Name.localeCompare(b.Model_Name)
        );
        
        setAllModels(sortedModels);
        
      } else {
        throw new Error('Invalid data format received from models API');
      }
      
    } catch (err) {
      console.error('❌ Error fetching vehicle models:', err);
      setError(err.message);
      setAllModels([]);
    } finally {
      setLoading(false);
    }
  };

  // Filtrar modelos basado en el término de búsqueda
  const filteredModels = useMemo(() => {
    if (!searchTerm.trim()) {
      return allModels; // Mostrar todos los modelos
    }
    
    return allModels.filter(model => {
      const modelName = model.Model_Name || '';
      return modelName.toLowerCase().includes(searchTerm.toLowerCase());
    });
  }, [allModels, searchTerm]);

  useEffect(() => {
    fetchModels(makeId);
  }, [makeId]);

  return {
    allModels,
    filteredModels,
    loading,
    error,
    searchTerm,
    setSearchTerm,
    refetch: () => fetchModels(makeId)
  };
};
